export default {
  pickupRouteList: [],
  pickupRouteStudentList: [],
  pickupRouteInfo: {
    bus_info: {
      id: ''
    },
    parent_info : {
      id: ''
    },
    place_list: []
  },
  selected: [],
  parentPickupRouteList: [],
  currentFilter: null,
  currentSort: null,
  currentPage: null
}
